// @flow
import * as React from "react"
import MaskedInput from "react-text-mask"

import Text from "./Text"

const MASK = [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, ":", /\d/, /\d/]

export default (props: {}) => <Text placeholder="__/__/____ __:_" {...props} component={MaskedInput} mask={MASK} />
